// What the success page says once the finalize answers. Imports nothing,
// so node --test can run it (checkout-outcome.test.mjs).
//
// finalizeOrder (store/hooks/use-orders-api.js) answers the order's data on
// success and null on any failure. Null is never "You're booked!": the card
// went through Stripe but the booking did not finalise, and the team has
// been told (Order::UnconfirmedAlertWorker). Referral audit, 25 Oct 2026.
// British English, no em dashes in customer copy.
export const finalizeOutcome = result => (result && typeof result === 'object' ? 'booked' : 'unconfirmed')

export const UNCONFIRMED_HEADING = 'We couldn’t confirm your booking yet'

export const UNCONFIRMED_TEXT = 'Something went wrong on our side while confirming it. Our team has been told and we’ll be in touch shortly to sort it out.'
